import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { filter, pipe, switchMap } from 'rxjs';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setLoaded, withCallState } from '@ngrx-toolkit/core';
import type { Statuses } from '../../types';
import { DictionariesService } from './dictionaries.service';

type State = {
  courtStatuses: Statuses;
  paymentStatuses: Statuses;
  documentTypes: Statuses;
};

const initialState: State = {
  courtStatuses: [],
  paymentStatuses: [],
  documentTypes: [],
};

export const DictionariesStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCallState(),
  withComputed(({ courtStatuses, paymentStatuses, documentTypes }) => ({
    courtStatusOptions: computed(() => courtStatuses().map((status) => ({ name: status.name, value: status.code }))),
    paymentStatusOptions: computed(() =>
      paymentStatuses().map((status) => ({ name: status.name, value: status.code })),
    ),
    documentTypeKeys: computed(() => documentTypes().map((type) => type.code)),
  })),
  withMethods((store, api = inject(DictionariesService)) => ({
    load: rxMethod<void>(
      pipe(
        filter(() => !store.loaded()),
        switchMap(() =>
          api.load().pipe(
            tapResponse({
              next: (dictionaries) => patchState(store, dictionaries, setLoaded()),
              error: () => patchState(store, initialState),
            }),
          ),
        ),
      ),
    ),
  })),
);
